import React from 'react';

import {trackEvent} from '../../../../lib/analytics';

import {
  Container,
  PaymentMethodInfo,
  PaymentTitle,
  PaymentSubtitle,
  PaymentInfo,
  Payment,
  BrandContainer,
  BrandImage,
  CheckIcon,
} from './style';
import { usePaymentMethod } from '../CheckoutSession/hooks/usePaymentMethod';

type Props = {
  selectedPaymentMethod?: unknown;
  changePaymentMethod?: (method: 'PIX') => void;
};

export function PixPaymentMethod({
  selectedPaymentMethod: propMethod,
  changePaymentMethod: propChange,
}: Props) {
  const {changePaymentMethod: globalChange, selectedPaymentMethod: globalMethod} =
    usePaymentMethod();

  const selectedPaymentMethod = propMethod ?? globalMethod;
  const changePaymentMethod = propChange ?? globalChange;

  function handlePaymentMethod(method: 'PIX') {
    trackEvent('adiciona_metodo_pagamento', {
      payment_type: method,
      currency: 'BRL',
    });

    changePaymentMethod(method);
  }

  return (
    <Container>
      <PaymentInfo activeOpacity={1} onPress={() => handlePaymentMethod('PIX')}>
        <Payment>
          <BrandContainer>
            <BrandImage
              source={{
                uri: 'https://d3ag5cip9ldvh3.cloudfront.net/card_brands/pix.png',
              }}
            />
          </BrandContainer>
          <PaymentMethodInfo>
            <PaymentTitle>PIX</PaymentTitle>
            <PaymentSubtitle>Pagamento instantâneo</PaymentSubtitle>
          </PaymentMethodInfo>
        </Payment>
        <CheckIcon
          name={selectedPaymentMethod === 'PIX' ? 'dot-circle' : 'circle'}
          check={selectedPaymentMethod === 'PIX'}
        />
      </PaymentInfo>
    </Container>
  );
}
